export const formatCurrency = (
  value: string | number | null | undefined = 0,
  showCents: boolean = true,
): string => {
  const stringValue = value?.toString().trim() ?? '';
  const normalizedValue = stringValue.replace(/[$,]/g, '');
  const numericValue =
    normalizedValue.length === 0 ? 0 : Number(normalizedValue);

  if (Number.isNaN(numericValue)) {
    return '';
  }

  const options: Intl.NumberFormatOptions = {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: showCents ? 2 : 0,
    maximumFractionDigits: showCents ? 2 : 0,
  };
  return new Intl.NumberFormat('en-US', options).format(numericValue);
};

export const parseCurrencyToNumber = (formatted: string): number => {
  return Number(formatted.replace(/\D/g, ''));
};

export const formatCurrencyWholeNumber = (rawDigits: string): string => {
  const digits = rawDigits.replace(/\D/g, '');
  if (digits === '' || digits === '0') {
    return '';
  }
  return formatCurrency(Number(digits), false);
};

export const formatCurrencyInput = (input: string): string => {
  const normalizedInput = input.replace(/[$,\s]/g, '');
  const decimalIndex = normalizedInput.indexOf('.');
  const wholeDollarInput =
    decimalIndex === -1
      ? normalizedInput
      : normalizedInput.slice(0, decimalIndex);
  const centInput =
    decimalIndex === -1 ? undefined : normalizedInput.slice(decimalIndex + 1);
  const wholeDollarDigits = wholeDollarInput.replace(/\D/g, '');
  const centDigits = centInput?.replace(/\D/g, '').slice(0, 2);

  if (wholeDollarDigits === '' && decimalIndex === -1) {
    return '';
  }

  const normalizedWholeDollarDigits =
    wholeDollarDigits.replace(/^0+(?=\d)/, '') || '0';
  const formattedWholeDollars = normalizedWholeDollarDigits.replace(
    /\B(?=(\d{3})+(?!\d))/g,
    ',',
  );

  return centDigits === undefined
    ? `$${formattedWholeDollars}`
    : `$${formattedWholeDollars}.${centDigits}`;
};
